import { useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLink, faBold, faItalic, faImage, faUnderline } from "@fortawesome/free-solid-svg-icons";
import classNames from "classnames";

export const FormatBar = ({onImageChange}) => {

    const handleImage = (e) => {
        onImageChange(e);
    }

    const fileBtnRef = useRef();

    return (
        <div className="format-bar">
            <>
                <input
                    type="file"
                    className="file-btn-input"
                    onChange={(e) => handleImage(e)}
                    ref={fileBtnRef}
                />
                <button
                    className="format-btn"
                    onClick={(e) => {
                        e.preventDefault();
                        fileBtnRef.current.click();
                    }}
                >
                    <FontAwesomeIcon icon={faImage} />
                </button>
            </>

            <button
                className="format-btn"
                onClick={(o) => {
                    o.preventDefault();
                    let linkURL = prompt('Enter URL:', 'https://pathtoUrl')
                    document.execCommand('createLink', true, linkURL)
                }}
            >
                <FontAwesomeIcon icon={faLink} />
            </button>
            <button
                className={classNames("format-btn") }
                onClick={(e) => {
                    e.preventDefault();
                    document.execCommand('bold')
                }}

            >
                <FontAwesomeIcon icon={faBold} />
            </button>
            <button
                className="format-btn"
                onClick={(e) => {
                    e.preventDefault();
                    document.execCommand('italic')
                }}
            >
                <FontAwesomeIcon icon={faItalic} />
            </button>
            <button
                className="format-btn"
                onClick={(e) => {
                    e.preventDefault();
                    document.execCommand('underline')
                }}
            >
                <FontAwesomeIcon icon={faUnderline} />
            </button>
        </div>
    )
}